import axiosPublicClient from "../../../../axiosPublicClient"

const service = async ({
    key,
    file,
    fileName,
    fileExtension,
}) => {

    // Step 1: Get the pre-signed S3 upload URL
    const candidateMediaUrlResponse = await axiosPublicClient.post(`/candidate-media-url`, {
        key,
        fileName,
        fileExtension,
    })

    if (!candidateMediaUrlResponse?.data?.url || !candidateMediaUrlResponse?.data?.key) {
        throw new Error("Upload URL or key missing from response")
    }

    const { url, key: assetKey, } = candidateMediaUrlResponse.data

    // Step 2: Upload the file to the S3 pre-signed URL
    await axiosPublicClient.put(url, file, {
        headers: {
            "Content-Type": file.type,
        },
    })

    return {
        key: assetKey,
    }
}

export default service
